import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, scan, shareReplay, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-sort-button',
  templateUrl: './sort-button.component.html',
  styleUrls: ['./sort-button.component.scss']
})
export class SortButtonComponent implements OnInit {

  @Output() order = new EventEmitter<number>();

  public $sortOrder = new Subject();
  public sortOrder$ = this.$sortOrder.pipe(
    startWith(0),
    scan(order => order > 0 ? -1 : 1, -1),
    // if you want to be able to set the sort order directly instead of cycling it:
    // scan((order: number, forceOrder: number) => forceOrder !== undefined ? forceOrder : order > 0 ? -1 : order + 1, -1),
    distinctUntilChanged(),
    tap(order => this.order.emit(order)),
    shareReplay(1),
  );

  constructor() { }

  ngOnInit(): void {
  }

}
